import * as React from 'react';
import PlannerButton from "./PlannerButton";
import { Conduit, TargetType, Graft, TargetLocation, TargetDetails } from "./TriggerClasses";
import HeartDrawingOverlay from "./HeartDrawingOverlay";
import { AppContext } from '../../AppContext';

class GraftBuilder extends React.Component< 
{ 
  setCustomGraft: Function, 
  customGraftText: string, 
  frequentGraftSelected: Function,
  //In simple mode frequent grafts, annotations and buttons are hidden.
  simpleMode: boolean,
  Context: string, 
  graftsUpdated: Function,
  editGraftClicked: Function,
  subGraftSelected: Graft,
  CurrentGraft: Graft,
  SaveGraft: Function,
  closeGraftBuilder: Function,
}, {
  tabSelected: string, 
  show3dview: boolean, 
  waitingCustomTargetSet: boolean, 
  waitingCustomTargetHeartSideSet: boolean, 
  heartOutlineShow: boolean,
  heartTargetsShow: boolean,
    customGraftLocation: TargetLocation,
    quickError: string,
    CurrentGraft: Graft,
    quickDefGraft: Graft,
    previousTarget: TargetType,
    yTypeSelected: string,
    inflowPreference: string,
 } > {

    constructor(props: any) {
        super(props);
        
        this.state ={
          //Blank plan to start
          tabSelected: "Frequent",
          show3dview: false,      
          waitingCustomTargetSet: false,
          waitingCustomTargetHeartSideSet: false,
          heartOutlineShow: true,
          heartTargetsShow: true,
          customGraftLocation: { x: 0, y: 0, backOfHeart: false },
          quickError: "",
          CurrentGraft: this.props.CurrentGraft,
           quickDefGraft: this.props.CurrentGraft,
           previousTarget: TargetType.LAD,
           yTypeSelected: "",
           inflowPreference: ""
        }
        this.lastGraftClicked = [];
      }

      static defaultProps = {
        simpleMode: false,
        subGraftSelected: null,
        graftsUpdated: ()=>
        {}
      }

      componentDidMount = () => {
        console.log("PlannerScreen");
       console.log(this.state.CurrentGraft);
        (this.context as any).showPopup(true);
      }

        componentWillUnmount(): void {
            (this.context as any).showPopup(false);
        }

      //The graft click history
      lastGraftClicked: Graft[];
 
      graftRemoved: Graft | null = null;
      reportWindowSize = () => {
        
      }
  
       conduitToggled = (e: any, conduitItem: Conduit, callback?: () => void) => {
    console.log("Conduit Toggled");
    let callbackToUse = ()=>
    {
        this.mergeIntoCurrentGraft(this.state.quickDefGraft, callback as any, "", "conduitToggled");
        
    }
    //The conduit at the top of quick definitions is always the bottom most conduit.
    let planHolder = Graft.recurseFindBottomConduit(this.state.quickDefGraft, false);
    if (!planHolder)
    {
        //If there is no bottom then take the top level graft which is most likely a blank new graft.
        planHolder = this.state.quickDefGraft;
    }
    planHolder.draft = true;
    //TODO: Could recurse through children to find other conduits in use if required.
    //let conduitFound = this.context.recurseConduits(this.state.quickDefGraft, conduitItem);

    //If it's top level and the same conduit then clear it
    if (planHolder.conduit === conduitItem)
    {
        //If it has a target and that target has it's own conduit however then it could an issue.
      // if it is selected then clear it.
      planHolder.conduit = "" as Conduit;
      planHolder.title = "";
      //Make it a blank item.
      planHolder.blankNewItem = true;
    planHolder.inSitu = false;
    
    }
   else  if (planHolder.inEdit )
   {
       //If it is undergoing an edit it may be a more simple garft layout so hjuist set the conduit.
       planHolder.conduit = conduitItem;
       planHolder.title = conduitItem;
   }else {

   
    //  planHolder.Id = "UNDEFINED_GRAFT";
    //  planHolder.GroupId = "UNDEFINED_GRAFT";
    planHolder.conduit = conduitItem;
    if (!(planHolder.name && planHolder.type === "Target"  ))
    {
        if (!this.state.CurrentGraft.targets || this.state.CurrentGraft.targets.length === 0)
        {
            planHolder.type = "Source";
        }else
        {
            planHolder.type = "Conduit";
        }
     
    }
   
    planHolder.title = conduitItem;
    //Default sources to in Situ usage.
    planHolder.inSitu = TargetDetails.getTargetDetail(conduitItem).isSource;
   }
   let NewInflowValue = null;
   if (!TargetDetails.getTargetDetail(conduitItem).isSource)
   {
        NewInflowValue = "AORTA";
        planHolder.aortaSelected = true;
   }else
   {
        planHolder.aortaSelected = false;
   }
   if (!this.state.CurrentGraft.draft && this.state.inflowPreference)
   {
    NewInflowValue = this.state.inflowPreference;
   }
   if (this.state.CurrentGraft.draft && this.state.CurrentGraft.conduit)
   {
    NewInflowValue = this.state.CurrentGraft.conduit;
   }

   this.setState({quickDefGraft: planHolder, inflowPreference: NewInflowValue as string }, callbackToUse);
   
 
}


   
 
// recurseTargets = (currentGraft: Graft, targetToCheckFor: TargetType, remove?: boolean): boolean => 
// {
//   if (currentGraft.name === targetToCheckFor)
//     {
      
//       return true;
//     }
//     if (currentGraft.targets && currentGraft.targets.length > 0)
// {
//   let isFound = false;
//   for (let index = 0; index < currentGraft.targets.length; index++) {
//     const element = currentGraft.targets[index];

//     if (remove)
//       {
//         if (element.name === targetToCheckFor)
//         {
//           this.graftRemoved = element;
//                  //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
//                  //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
//                    //Set the previous to the last graft clicked before it changes.
          
//                    //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
          

//           //Take the parent as the next item in the default focus tree.
//           //this.previousGraftClicked = currentGraft;
//           currentGraft.targets.splice(index, 1);
            
//           isFound = true;
          
//         }else
//         {
//           isFound = this.recurseTargets(element, targetToCheckFor, remove);
//         }
//       }
//       else{
//         isFound = this.recurseTargets(element, targetToCheckFor);
//       }
//       if (isFound)
//       {
//         return isFound;
//       }
//   }
 
// }
// return false;
// }

selectTab = (tabName: string) =>
{
  this.setState({
      tabSelected: tabName
  });
}

subTabSelected = (e: any) =>
{
  let tabSelected = e.currentTarget.id;
  this.selectTab(tabSelected);
}

customTextChanged = (typeName: string, textValue: string) =>
{
  if (typeName === "CUSTOM" && textValue)
  {
    this.props.setCustomGraft(textValue, null);
    this.setState({
      
      waitingCustomTargetSet: true
  });

//Now wait for mousedown and set location.

  }
}
mouseDownOnPlanner = (e: any)=>
{
  if (this.state.waitingCustomTargetSet)
  {
    console.log("mouseDownOnPlanner");
    if (document.getElementById("heart-drawing-container-Planner") !== null)
    {
      let xToUse = e.clientX - (document.getElementById("heart-drawing-container-Planner") as HTMLElement).getBoundingClientRect().x;
      let yToUse = e.clientY - (document.getElementById("heart-drawing-container-Planner") as HTMLElement).getBoundingClientRect().y;
    let coordsToUse = { x: xToUse, y : yToUse };//(this.refs.drawingOverlay as HeartDrawingOverlay).transferToScreenSize( { x: xToUse, y : yToUse });
        console.log("clientX: " + coordsToUse.x);
        console.log("clientY: " + coordsToUse.y);


        this.setState({
        waitingCustomTargetSet: false,
        waitingCustomTargetHeartSideSet: true,
        customGraftLocation: coordsToUse
    }, ()=>{

    
    });
    }
  }

  // console.log("clientX: " + (e.clientX - document.getElementById("HeartDrawingOverlay-"+this.props.Context).getBoundingClientRect().x));
  // console.log("clientY: " + (e.clientY - document.getElementById("HeartDrawingOverlay-"+this.props.Context).getBoundingClientRect().y));
}




setCustomTargetFrontOrBack = (backOfHeart: boolean)=>
{

let currentValue = this.state.customGraftLocation;
currentValue.backOfHeart = backOfHeart;
this.setState({
  waitingCustomTargetSet: false,
  waitingCustomTargetHeartSideSet: false,
  customGraftLocation: currentValue
});
  this.props.setCustomGraft(this.props.customGraftText, currentValue);
  this.targetToggled(null, TargetType.CUSTOM, ()=>{});
}
freqConduitsContainer: React.ReactElement[] = [];
    otherConduitsContainer: React.ReactElement[] = [];
    rightTargetsContainer: React.ReactElement[] = [];
    leftTargetsContainer: React.ReactElement[] = [];

    freqInflowConduitsContainer: React.ReactElement[] = [];
    otherInflowConduitsContainer: React.ReactElement[] = [];
    other2InflowConduitsContainer: React.ReactElement[] = [];
    complexGraftToolbar: React.ReactElement = <></>;
    targetHasBeenSelected: boolean = false;
    graftFound: Graft = null as any;
    
isInflowUsed = (conduit: Conduit, inSitu: boolean): boolean =>
{
    return  (!this.state.CurrentGraft.draft && this.state.CurrentGraft.conduit === conduit && this.state.CurrentGraft.inSitu === inSitu && !this.state.CurrentGraft.aortaSelected);
}

targetInUse = (targetIn: TargetType, isSelected: boolean): boolean =>
{
    let alreadyInUse = Graft.recurseTargets(this.state.CurrentGraft, targetIn, false, true);
    return alreadyInUse;
}

conduitInUse = (conduit: Conduit): boolean =>
{
   let conduitUsed =  Graft.recurseConduits(this.state.CurrentGraft, conduit, false, false, true);
   return conduitUsed;
} 
 recurseSetDraft = (graftIn: Graft, draftValue: boolean, removeDraft: boolean = false, undoOperation: boolean = false): Graft | null =>
    {
        let graftParent: Graft | null = null;
        if (!removeDraft)
            graftIn.draft = draftValue;
        if (graftIn.targets)
        {
            for (let index = 0; index < graftIn.targets.length; index++) {
                const element = graftIn.targets[index];
                if (removeDraft)
                {
                    if (element.draft && (element.type === "Target" || undoOperation))
                 {
                    graftIn.targets.splice(index, 1);
                    graftParent = graftIn;
                 }    
                }
  
                let graftOut = this.recurseSetDraft(element, draftValue, removeDraft, undoOperation);
                if (graftOut !== null)
                    graftParent = graftOut;
                
            }
        }
        return graftParent;
    }
    lastAddedTarget: TargetType | null = null;
    confirmedParentTarget: TargetType | null = null;

PlanDeleted = (graftIn : Graft): Graft => {
        if (!graftIn)
            graftIn = this.state.CurrentGraft;
        // this.removeAutoGenerated(graftIn.GroupId, true);
        let blankGraft : Graft = Graft.getBlankGraft(true);
        blankGraft.inEdit = true;
        this.setState({CurrentGraft: blankGraft});

        // if (this.refs.plannerContainer) 
        //     (this.refs.plannerContainer as PlannerContainer).updateWorklist(blankGraft, false);

            return blankGraft;

        }
checkInflowButton= (conduit: Conduit, inSitu: boolean): boolean =>
{
    if ((conduit as string) === "AORTA" && this.state.CurrentGraft.aortaSelected)
    {
        return true;
    }
    else
        return (((this.state.CurrentGraft.inSitu && inSitu) || (!this.state.CurrentGraft.inSitu && !inSitu)) && this.state.CurrentGraft.conduit === conduit && !this.state.CurrentGraft.aortaSelected);
    // && (!this.context.recurseFindBottomConduit(this.state.quickDefGraft) ||
    // this.context.recurseFindBottomConduit(this.state.quickDefGraft).Conduit === this.state.quickDefGraft.Conduit))


}

mergeIntoCurrentGraft = (graftIn: Graft, callback: (graftOut: Graft) => void, targetToAddYOn: string, operationType: string, previousTarget: TargetType | null = null, parentGraft: Graft | null= null ) =>
    {
        //let graftIn: Graft = {...graftInput};
        let graftMain: Graft;
        if (parentGraft)
            graftMain = parentGraft;
        else
            graftMain = this.state.CurrentGraft;
        if (operationType === "ClearDraft")
        {
            this.confirmedParentTarget = this.lastAddedTarget;
            this.recurseSetDraft(graftIn, false);
            
            return;
        }
        if (operationType === "Undo")
        {
            //this.confirmedParentTarget = this.lastAddedTarget;
            let parentOut = this.recurseSetDraft(graftIn, false, true, true);
            if (!parentOut || (parentOut.type ==="Source" && parentOut.targets && parentOut.targets.length === 0 )  )
            {
                parentOut = this.PlanDeleted(parentGraft as Graft);
            }
            //this.editGraftClicked(parentOut, null, this.CurrentStage, null);
            callback(parentOut as Graft);
            return;
        }
        else if (operationType === "removeTarget")
        {
            //If it's a plain old remove target then just remove it.
            if (this.lastAddedTarget === targetToAddYOn)
            {
                this.lastAddedTarget = null;
            }
            this.targetToggled(null, targetToAddYOn as TargetType, callback);
            return;
        }else if (operationType === "inflowToggled")
        {
            let graftToSet: Graft | null = null;
            //If the inflow is toggled and it is not a new graft just find the root conduit and set it to the current inflow.

            

            if (graftIn.conduit === graftMain.conduit)
            {
                graftToSet = { ...graftMain };
                graftToSet.inSitu = graftIn.inSitu;
                graftToSet.aortaSelected = graftIn.aortaSelected;
               
            }else if (!graftMain.targets || graftMain.targets.length === 0)
            {
                graftToSet = { ...graftMain };
                graftToSet.conduit = graftIn.conduit;
                graftToSet.title = graftIn.title;
                graftToSet.inSitu = graftIn.inSitu;
                graftToSet.aortaSelected = graftIn.aortaSelected;
                graftToSet.targets = [ ...graftIn.targets as Graft[]];
                graftToSet.type = "Source";
                //graftToSet.InEdit = false;
               
            } else 
            {
                

                graftToSet = { ...graftMain };
                //If the current graft has a bottom target in draft it needs to gave its conduit set and tacked on the bottom
                let bottomTarget = Graft.recurseFindBottomTarget(graftToSet);
                if (bottomTarget && bottomTarget.draft)
                {
                    bottomTarget.conduit = graftToSet.conduit;
                   bottomTarget.sequential = false;
                }

                let graftFound = Graft.recurseFindBottomConduit(graftToSet, false);
                //If the bottom conduit is the conduit set then remove targets and
                if (graftFound)
                {
                    if (graftFound.conduit === graftIn.conduit)
                    {
                        //THen make it sequentgial and drop it off (UNless it has a target)
                        if (graftFound.name)
                        {
                        graftFound.sequential = true;
                        (graftFound as any).conduit = null;
                        graftToSet.targets = [graftFound];
                        }
                        else
                        {
                            graftToSet.targets = [];
                        }
                    }
                }
                if (graftToSet.conduit === graftIn.conduit)
                {
                    graftToSet.targets = [];
                }
                graftToSet.conduit = graftIn.conduit;
                graftToSet.title = graftIn.title;
                graftToSet.inSitu = graftIn.inSitu;
                graftToSet.aortaSelected = graftIn.aortaSelected;
                graftToSet.type = "Source";
               // graftToSet.InEdit = false;
               
            }
            if (!parentGraft)
            {
            this.setState({
                CurrentGraft: graftToSet
            },()=> {
             
                 if (callback)
                     callback(graftToSet as Graft);
             });
            }
             return;
        }else if (operationType === "targetToggled")
        {
            //first remove any draft targets.
            //this.recurseSetDraft(this.state.CurrentGraft, false, true);

            let graftToSet = { ...this.state.CurrentGraft };
            if (graftIn.inEdit && graftIn.type === "Target")
            {
                if (Graft.recurseTargets(graftToSet, previousTarget as TargetType, false) && Graft.graftFound)
                {
                    Graft.graftFound.name = graftIn.name;
                    Graft.graftFound.title = graftIn.title;
                }
                
            }else
            {
            let bottomTarget: Graft =Graft.recurseFindBottomTarget(graftToSet) as Graft;
                let LateY = false;
            if (graftIn.conduit && graftToSet.conduit !== graftIn.conduit)
            {
                //If the new graft has an explicit conduit and it is not the same as the route try recurse to find the bottom conduit of it.
                Graft.setRecurseGraft(null);
                if (Graft.recurseConduits(graftToSet, graftIn.conduit,  false, true))
                {
                    LateY = true;
                    bottomTarget = Graft.getRecurseGraft() as Graft;
                }

            }

            //If there is no bottom target the find the bottom conduit.
            
            if (!bottomTarget)
                bottomTarget = Graft.recurseFindBottomConduit(graftToSet, false) as Graft;

            
           if (!bottomTarget)
            bottomTarget = graftToSet;

            if (bottomTarget.conduit && bottomTarget.conduit !== graftIn.conduit)
            {

                //If it's not sequential then we want to add it to the first target of the last used targets conduit.
                Graft.setRecurseGraft(null);
                Graft.recurseConduits(graftToSet, graftToSet.conduit as Conduit, false, true, false);
                        let firstConduit = Graft.getRecurseGraft();
                        if (firstConduit)
                            bottomTarget = firstConduit;
                        // //If it has no targets then use the first conduit found. 
                        // if ((!firstConduit.Targets ||firstConduit.Targets.length === 0))
                        //     bottomTarget = firstConduit;
                        // else
                        //     //If it does have targets then add it to the first one.
                        //     bottomTarget = firstConduit.Targets[0]; 
                    }

            let targetToAdd = Graft.recurseFindBottomTarget(graftIn) as Graft;
            
            //targetToAdd.Draft = false;
                    this.lastAddedTarget = targetToAdd.name as TargetType;
                    //Remove the old one.

                   // this.recurseTargets(graftToSet, targetToAdd.Name, true);
                    if (!bottomTarget.targets)
                    bottomTarget.targets =[];
                    targetToAdd.inEdit = false;
                    if(targetToAdd.id !== bottomTarget.id)
                    {
                    //If it's sequential add it to the top of the list
                    if (targetToAdd.sequential && !LateY)
                    {   
                        //Tack existings targets in the bottom of the top sequential so Y's are created.
                        let existingTargets = bottomTarget.targets;
                        targetToAdd.targets = existingTargets;
                        if (bottomTarget.id !== targetToAdd.id)
                            bottomTarget.targets = [targetToAdd];


                    }
                     
                    else 
                    {
                            //If it's not sequential then add to the top conduit instead.
                            bottomTarget = Graft.recurseFindBottomConduit(graftToSet, true) as Graft;
                            if (bottomTarget && bottomTarget.id !== targetToAdd.id)
                                //Otherwise tack it on the bottom.
                                bottomTarget.targets?.push( {...targetToAdd});
                    }
                       
                }
                
                }
                if (!parentGraft)
                {
                this.setState({
                    CurrentGraft: graftToSet
                },()=> {
                 
                     if (callback)
                         callback(graftToSet);
                 });
                }else
                {
                    if (callback)
                         callback(graftToSet);
                }
                 return;
            
        }
        else if (operationType === "conduitToggled")
        {
            //If we are editting then find the target given, set the conduit
            let graftToSet = { ...graftMain };
            let bottomTarget = Graft.recurseFindBottomTarget(graftIn);
            if (bottomTarget)
            {
                //If it has a target attached then look for that and set the conduit.
                let conduitIn = graftIn.conduit;
                bottomTarget.conduit = conduitIn;
                graftIn = bottomTarget;
            }
            if (graftIn.inEdit || (graftIn.draft && (graftIn.type === "Target")))
            {
                let graftFoundLocal: Graft | null = null;
                Graft.graftFound = null;

                if (Graft.recurseTargets(graftToSet, graftIn.name as TargetType, false))
                {
                    graftFoundLocal = Graft.graftFound as any;
                }
               
                if (graftFoundLocal)
                {
                    let parentGraft = graftFoundLocal;
                    //If it's sequential then set its parents conduit instead.
                    if (graftFoundLocal.sequential && !graftFoundLocal.conduit)
                    {

                        parentGraft = Graft.recurseFindTargetParent(graftToSet, graftIn.name as TargetType) as Graft;
                    }
                            //If it's a source what should be do with insitu?
                           // TargetDetails.getTargetDetail(conduitItem).isSource;
                            parentGraft.conduit = graftIn.conduit;
                            // Recurse and set all sequentials to use the same conduit
                            Graft.recurseAndUpdateConduits(parentGraft, graftIn.conduit as Conduit);
                            if (parentGraft.type === "Source" && graftIn.conduit)
                            {
                                parentGraft.aortaSelected = graftIn.aortaSelected;
                                parentGraft.title = parentGraft.conduit;
                                parentGraft.inSitu = TargetDetails.getTargetDetail(parentGraft.conduit as Conduit).isSource;
                            }
                                
                    if (Graft.graftFound)   
                    {
                        if ((Graft.graftFound as any).conduit)
                            (Graft.graftFound as any).conduit = graftIn.conduit;

                        //If it's a new graft but we are setting the conduit then make sure to set the type to source.
                        if ((Graft.graftFound as any).type === "NewGraft")
                            (Graft.graftFound as any).type = "Source";
                    }

                }else{
                    console.error("Tried to edit a target that does not exist: " + graftIn.name);
                }

            }else
            {
           
                let graftFound = Graft.recurseFindBottomConduit(graftToSet, false);
                if (!graftFound)
                {
                    graftFound = graftToSet;
                    (graftFound as any).type = "Source";
                }
                else
                {
                    if (graftFound.draft)
                    (graftFound as any).type = "Conduit";
                }
                if (this.confirmedParentTarget)
                {
                    
                }
                if (!this.confirmedParentTarget && (graftFound.conduit === graftIn.conduit || graftToSet.blankNewItem))
                {
                    //You cannot extend from the same inflow to the same conduit so reset the graft to a single level.
                    
                   
                        //if however the bottom graft has a target already then we don't want to do anything
                        if (graftFound.type !== "Target")
                        {

                            graftFound = graftToSet;
                            graftFound.type = "Source";
                            graftFound.targets = [];
                        
                        }
                    
                
                }else{
                    Graft.graftFound = null;
                    
                    //If it's sequential then continue from the last target
                    if (Graft.recurseTargets(graftToSet, this.confirmedParentTarget as TargetType, false))
                    {
                        graftFound = Graft.graftFound;
                    }

                    if ((graftFound as any).conduit !== graftIn.conduit)
                    {
                        //If it's not sequential then we want to add it to the first target of the last used targets conduit.
                        Graft.setRecurseGraft(null);
                        Graft.recurseConduits(graftToSet, graftIn.conduit as Conduit, false, true, false);
                        let firstConduit = Graft.getRecurseGraft();
                        //Find the bottom of the matching conduit and add to that one.
                        if (firstConduit)
                            graftFound = firstConduit;
                        // if ((!firstConduit.Targets ||firstConduit.Targets.length === 0))
                        //     graftFound = firstConduit;
                        // else
                        // {
                        //     //May need to recurse to find bottom of sequential.
                        //     if (firstConduit.Targets[0].Sequential)
                        //         //If it does have targets and it is sequential then add it to the first one.
                        //         graftFound = firstConduit.Targets[0]; 
                        //     else
                        //         //Otherwise use the top one
                        //         graftFound = firstConduit;
                        // }
                    }
                }

                if (graftFound)
                {
                if (graftFound.draft && graftIn.conduit)
                {
                graftFound.conduit = graftIn.conduit;
                graftFound.title = graftIn.title;

                graftFound.inSitu = graftIn.inSitu;
                graftFound.draft = graftIn.draft;
                graftFound.aortaSelected = graftIn.aortaSelected;
                if (graftIn.targets && graftIn.targets.length > 0)
                    graftFound.targets = [...graftIn.targets];
                }
                else
                {
                    //let graftFound = this.recurseFindBottomTarget(graftToSet);
                    
                    
                    //If it is not in draft then we need to tack on the conduit to the bottom target.
                    if (!graftFound.targets)
                        graftFound.targets = [];

                        graftIn.type = "Conduit";
                        if ((graftFound.conduit && graftFound.conduit !== graftIn.conduit) || (!graftFound.conduit && graftToSet.conduit !== graftIn.conduit))
                        {
                            graftIn.sequential = false;
                            //If it's not sequential then add to the top graft instead.
                            graftFound = Graft.recurseFindBottomConduit(graftToSet, true);
                           
                            //this.recurseFindBottomConduit(graftToSet)
                        }
                    if (graftIn.conduit)
                    {
                        if (graftFound)
                        {
                        if (graftFound.targets && graftFound.targets.length > 0)
                        {
                            //Find first non sequential or end of list and add before that. 
                            let indexToAdd = 0; 
                            for (let index = 0; index < graftFound.targets.length; index++) {
                                const element = graftFound.targets[index];
                                indexToAdd = index;
                                if (!element.sequential)
                                {
                                    break;
                                }else
                                {
                                    //if it's not sequential then add one so it adds after the last sequential.
                                    indexToAdd++;
                                }
                            }
                            //There needs to be at least one sequential so tack all remaining grafts after this one.
                            if (indexToAdd < graftFound.targets.length)
                            {
                                graftFound.targets.splice(indexToAdd, 0, graftIn);                            
                            }
                            else
                            {
                                graftFound.targets.push(graftIn);
                            }
                        }else
                        {
                            graftFound.targets?.push(graftIn);
                        }
                    }
                            
                    }
                       
                }

            }
        }
            if (!parentGraft)
            {
                this.setState({
                    CurrentGraft: graftToSet
                },()=> {
                 
                     if (callback)
                         callback(graftToSet);
                 });
                }else
                {
                    if (callback)
                         callback(graftToSet);
                }
                 return;
        }

        //First look for the Conduit
        //Recurse Conduits needs to find the bottom conduit.
        Graft.setRecurseGraft(null);
        let conduitFound: boolean = Graft.recurseConduits(graftMain, graftIn.conduit as Conduit, false, true);
        let planHolder: Graft = Graft.getRecurseGraft() as Graft;
        let bottomTarget: Graft =Graft.recurseFindBottomTarget(graftMain) as Graft;

        let targetFound: boolean = false;


        //We actually want to the find the bottom child of the conduit selected if it exists.
        if (conduitFound)
        {
            Graft.setRecurseGraft(null);
            if (Graft.recurseConduits(graftMain, graftIn.conduit as Conduit, false, true))
            {
                 let bottomItemFound = Graft.getRecurseGraft() as Graft;
                if (bottomItemFound.name && bottomItemFound.type === "Target")
                {
                    bottomTarget = bottomItemFound;
                }
            }
                
        }else
        {
            if (bottomTarget)
            {
                //If the conduit is not found then by default we want to find the highest target with the same conduit as the bottom target and add to that.
                //First find the Root conduit of the given bottom target
                //Give preference to the last target added.
                let rootConduit = Graft.recurseToFindRootConduit(graftMain,this.lastAddedTarget ? this.lastAddedTarget : bottomTarget.name as TargetType, this.state.CurrentGraft.conduit as Conduit);
                //Now search for the highest graft with that conduit.
                Graft.setRecurseGraft(null);
                if (Graft.recurseConduits(graftMain, rootConduit as Conduit))
                {
                    bottomTarget = Graft.getRecurseGraft() as Graft;
                    if (bottomTarget.type === "Source" && bottomTarget.targets && bottomTarget.targets.length > 0)
                    {
                        bottomTarget = bottomTarget.targets[0];
                    }
                }
            }

        }
        let targetOnAddingItem: Graft =Graft.recurseFindBottomTarget(graftIn) as Graft;

        if (targetOnAddingItem && targetOnAddingItem.name && targetOnAddingItem.type === "Target")
        {
            Graft.graftFound = null;
            //If the target being added already exists.
            targetFound = Graft.recurseTargets(graftMain, targetOnAddingItem.name); 
            // if (targetFound)
            //     bottomTarget = this.graftFound;
        } 

        if (operationType === "conduitToggled")
        {

        } else if (operationType === "inflowToggled")
        {
            //If the inflow is toggled and it is not a new graft just find the root conduit and set it to the current inflow.
            
        } else if (operationType === "targetToggled")
        {
            
        }
        else if (operationType === "yGraftTypeSelected")
        {
            
        }


          //If it finds the conduit and there is a target to set then add the graft sequentially to the planholder
        if (conduitFound && bottomTarget)
        {
            
          
            //Recurse and find the final target in the graftIn.
            //If there is a target to add and it is not the same as the current graft bottom one (Could actually just check if it exists) then add it.
            if (targetOnAddingItem && !targetFound)
            {
                if (bottomTarget.sequential && bottomTarget.type !== "Source")
                {
                    this.lastAddedTarget = targetOnAddingItem.name as TargetType;
                    //If the bottom target is sequential and not sourcethen add onto it.
                    bottomTarget.targets?.splice(0,0, {...targetOnAddingItem});
                    //If however we are still at the source
                    // if (bottomTarget.Type === "Source")
                    // {
                    //     //Check if it only has non sequential children.

                    //     //If so they need to be moved under this sequential being added.
                    // }else
                    // {

                    // }
                    //Add on at the start of the targets so Y grafts fall after it.
                    
                    // bottomTarget.Targets.push( {...targetOnAddingItem});
                }else
                {
                    //If not sequential but this one is (Which it should be because it is the same conduit.)
                    if (targetOnAddingItem.sequential && bottomTarget.type !== "Source")
                    {
                        
                    }else
                    {
                        //If it is not sequential then, based on the targetToAddYOn, find that target and add it to that one.
                        if (targetToAddYOn && targetToAddYOn !== "SEQ")
                        {
                            Graft.graftFound = null;
                            if (Graft.recurseTargets(graftMain, targetToAddYOn as TargetType, false))
                            {
                                planHolder = Graft.graftFound as any;

                            }
                            
                        }
                    

                    }
                    let TargetsBackup = [...planHolder.targets as Graft[]];
                        planHolder.targets = [];
                        let itemToAdd = {...targetOnAddingItem};
                        itemToAdd.targets = TargetsBackup;
                        this.lastAddedTarget = itemToAdd.name as TargetType;
                        planHolder.targets.push(itemToAdd);


                    
                }
              
            }else if (targetOnAddingItem && targetFound)
            {
                //If it's the same target tehn it is probably a Y change.
                 //If not sequential but this one is (Which it should be because it is the same conduit.)
                 if (!targetOnAddingItem.sequential)
                 {
                     //If it is not sequential then, based on the targetToAddYOn, find that target and add it to that one.
                     if (targetToAddYOn && targetToAddYOn !== "SEQ")
                     {
                         Graft.graftFound = null;
                         
                         //Find the target at which to add the Y.
                         if (Graft.recurseTargets(graftMain, targetToAddYOn as TargetType))
                         {
                             //Find the correct target to add it onto.
                             planHolder = Graft.graftFound as any;
                             //planHolder = this.recurseFindTargetParent(this.state.CurrentGraft, targetToAddYOn as TargetType);
                         }
                         //Remove the target being manipulated.
                         if (Graft.recurseTargets(graftMain, targetOnAddingItem.name as TargetType, true))
                         {
                             //Find the correct target to add it onto.
                             //planHolder = this.graftFound;
                             //planHolder = this.recurseFindTargetParent(this.state.CurrentGraft, targetToAddYOn as TargetType);
                         }
   //Else if it's the same target and no change in Y details it is most likely a toggle so remove it.
                  //  let TargetsBackup = planHolder.Targets;
                  //  planHolder.Targets = [];
                  let itemToAdd = {...targetOnAddingItem};
                  this.lastAddedTarget = itemToAdd.name as TargetType;
                  //itemToAdd.Targets = TargetsBackup;
                  planHolder.targets?.push(itemToAdd);

                     }
                 
                 
                
                 }
                 else
                 {
                     if (operationType === "yGraftTypeSelected")
                     {
                     //Remove the existing target
                    if (Graft.recurseTargets(graftMain, targetOnAddingItem.name as TargetType, true))
                    {
                            //If we remove the target, make sure to update the bottomTarget we are adding to to make sure it's not the one removed.
                            bottomTarget = Graft.recurseFindBottomTarget(graftMain) as Graft;
                    }
                    //And then add the new one to the bottom.
                    let itemToAdd = {...targetOnAddingItem};
                    this.lastAddedTarget = itemToAdd.name as TargetType;
                    //itemToAdd.Targets = TargetsBackup;
                    bottomTarget.targets?.push(itemToAdd);
                }
                 }
        
            }

           // this.recurseAndAddChild(this.state.CurrentGraft, bottomTarget.Name, bottomTarget);
           if (!parentGraft)
           { 
           this.setState({
                CurrentGraft: graftMain
            }, ()=> {
               let Conduitfound = graftMain;
               console.log(Conduitfound.conduit);
               
                if (callback)
                    callback(graftMain);
            });
        }else
        {
            
                if (callback)
                    callback(graftMain);
       
        }
        }else if (bottomTarget && targetOnAddingItem)
        {
            //If the conduit doesn't exist then add it to last current graft.
            // this.setConduit(bottomTarget.Name, graftIn.Conduit, targetOnAddingItem.Sequential ? "SEQ" :"",targetOnAddingItem.Name, ()=>
            // {
            //     if (callback)
            //         callback();
            // });
            if (!conduitFound)
            {   
                //MAJOR CHANGE BELOW! If a target is used again then add it to the bottom. It could be another connection to the same target.
                // if (bottomTarget.Name === targetOnAddingItem.Name)
                // {
                //     //If however the targets match then just set the conduit.
                //     bottomTarget.Conduit = graftIn.Conduit;
                //     if (graftIn.Conduit)
                //         targetOnAddingItem.Sequential = false;
                //     else
                //         targetOnAddingItem.Sequential = true;
                //     if (callback)
                //     callback();
                // }else
                // {
                //If the new conduit hasn't been used then set it on the target on adding and then add it.
                targetOnAddingItem.conduit = graftIn.conduit;
                //TODO: This must be removed when extensions are allowed.
                targetOnAddingItem.sequential = false;
                if (targetOnAddingItem.type === "Target")
                {
                    this.lastAddedTarget = targetOnAddingItem.name as TargetType;
                bottomTarget.targets?.push( {...targetOnAddingItem});
                }
                if (callback)
                    callback(graftMain);
                //}
            }
        }
        else if (bottomTarget)
        {
            if (graftIn.type === "Target")
            {
                this.lastAddedTarget = graftIn.name as TargetType;
                bottomTarget.targets?.push( {...graftIn});
            }
            if (callback)
            callback(graftMain);
        }else
        {
            this.lastAddedTarget = null;
            let graftToSet = {...this.state.CurrentGraft};
            let tempGraftIn = {...graftIn};
            graftToSet.conduit = tempGraftIn.conduit;
            graftToSet.title = tempGraftIn.title;
            graftToSet.type = "Source";
            graftToSet.inSitu = tempGraftIn.inSitu;
            graftToSet.draft = tempGraftIn.draft;
            graftToSet.targets = [...tempGraftIn.targets as Graft[]];
            //If there is no target set yet then just set the conduit of the root.
            if (!parentGraft)
            {
            this.setState({
                CurrentGraft: graftToSet
            }, ()=> {
               let Conduitfound = this.state.CurrentGraft;
               console.log(Conduitfound.conduit);
               
                if (callback)
                    callback(graftMain);
            });
        }else
        {
            if (callback)
                callback(graftMain);
        }
        }

        
    }

    setConduit = (targetItem: TargetType, conduitName: Conduit, yType: string, targetGiven: TargetType, callback: () => void) => {

        if (this.state.CurrentGraft.type === "PreGraft")
        {
          //If a pre grafting step is selected in the planner and a a conduit added then dont do anything for now.
          //Should probably find a new graft and select and change it.
          return;
        }
             //If the y type is sequential then just add it as a child.'
         console.log("setConduit - "+ conduitName);
         //Always add as a child of the target
        //First remove the older instance (There can be only one usage of a Target as a Target)
           if (Graft.recurseTargets(this.state.CurrentGraft, targetItem, true))
           {  
             //Assume for a Conduit to be set then a graft must exist in the first place.
             let GraftToAdd: Graft = this.graftRemoved as Graft;
     
             //If changed back to sequential then add it to the last changed graft (Hope it's not the one removed.). ----> see correction below
             //Correction, if changed back to SEQ then use targetGiven if it is given otherwise use the last one given
             if (yType === "SEQ")
             { 
               let lastGraftUsed: Graft;
               if (targetGiven)
               {
                   //if the target is given then Y from it is a SEQ
                   yType = targetGiven;
                  
               }else
               {
                   if (this.lastGraftClicked.length > 0)
                   {
                     lastGraftUsed  = this.lastGraftClicked.pop() as Graft;
                     yType = lastGraftUsed.name as TargetType;
                     this.lastGraftClicked.push(lastGraftUsed);
                   }else
                   {
                     //A y is not Possible then not sure what to do?
                     console.log("A y is not Possible then not sure what to do? - " + targetItem + "," + conduitName + "," + yType + "," + targetGiven);
                   }
                 }
             
             
               GraftToAdd.sequential = true;
               //Clear the conduit so it uses its parent
               (GraftToAdd as any).conduit = null;
             }else
             {
               GraftToAdd.sequential = false;
               GraftToAdd.conduit = conduitName;
             }
             
             Graft.recurseAndAddChild(this.state.CurrentGraft, yType as TargetType, GraftToAdd);
          
           }
           if (callback)
           {
               callback();
            }

     }

   

targetToggled = (e: any, targetItem: TargetType, callback: (g:Graft) => void) =>
    {
        let previousTarget: TargetType | null = null;
        //First lets see if the target exists on the currentgraft.
        let findExistingTarget = Graft.recurseFindBottomTarget(this.state.quickDefGraft);
        if (findExistingTarget && findExistingTarget.name !== targetItem)
        {
            previousTarget = findExistingTarget.name as TargetType;
            //If a target currently exists and it's not the current one then remove it.
            // this.context.recurseTargets(this.state.quickDefGraft,    findExistingTarget.Name, true);
            // this.mergeIntoCurrentGraft(null, ()=>
            // {

            // }, findExistingTarget.Name, "removeTarget");
           
        }

        //If the target already exists then it must either just be ignored or removed from the quick def.
       if (Graft.recurseTargets(this.state.CurrentGraft, targetItem))
       {
        
           //this.context.recurseTargets(this.state.quickDefGraft, targetItem, true);
           
          // return;
       } 
        let callbackToUse = ()=>
        {
            this.mergeIntoCurrentGraft(this.state.quickDefGraft, callback, "", "targetToggled",this.state.previousTarget );
           
        }

        //When toggling targets, we first need to remove the existing one.
        let bottomTarget = Graft.recurseFindBottomTarget(this.state.quickDefGraft);
        if (bottomTarget)
        {
            if (bottomTarget.name !== targetItem)
            {
                bottomTarget.name = targetItem;
                bottomTarget.title = targetItem;
                //this.context.recurseTargets(this.state.quickDefGraft, bottomTarget.Name, true);
            }
        }

      let targetFound = Graft.recurseTargets(this.state.quickDefGraft, targetItem);
      let planHolder: Graft;
      let graftToAddTo: Graft;
      if (!targetFound)
      {
      
    //     //If there is no last graft clicked then try find the last child in the  current graft and make it the last one.
    //     if (this.lastGraftClicked.length === 0)
    //     {
    //       let depthIn = 0;
    //       let largestdepth = 0;
          
    //       if (this.context.recurseToFindDepth(this.state.quickDefGraft, null, depthIn, largestdepth) > 0)
    //       {
    //         if (this.context.getDeepestGraft())
    //           this.lastGraftClicked = [this.context.getDeepestGraft()];
    //       }
         
    //     }

    //     if (this.lastGraftClicked.length > 0)
    //     {
    //     //Plan holder should actually be set to the last target added?
    //     graftToAddTo = this.lastGraftClicked.pop();
       
    //     //Pop the last graft to use it to add to.
    //     while (graftToAddTo != null && !this.context.recurseTargets(this.state.quickDefGraft, graftToAddTo.Name) )
    //     {
    //       //If it doesn'ty exit then pop the next one in the queue.
    //       if (this.lastGraftClicked.length > 0)
    //         graftToAddTo = this.lastGraftClicked.pop();
    //       else
    //         graftToAddTo = null;
    //     }
    //     if (graftToAddTo)
    //       this.lastGraftClicked.push(graftToAddTo);
    //   }

    //     if (!planHolder)
    //           {
    //       //Assume the last item is always the conduit. (CANNOT do this anymore)
       
    //       planHolder = this.state.quickDefGraft;
         
          
    //     }
    
    if (Graft.recurseFindBottomConduit(this.state.quickDefGraft, false))
    {
    Graft.recurseConduits(this.state.quickDefGraft, (Graft.recurseFindBottomConduit(this.state.quickDefGraft, false) as Graft).conduit as Conduit, false, true);
    
    planHolder = this.state.quickDefGraft;
   
    //Graft.getRecurseGraft();
    graftToAddTo = Graft.getRecurseGraft() as Graft;
        // if (!graftToAddTo)
        //     graftToAddTo = planHolder;
      //Need to recursively find the target and remove it.
        
        if (!graftToAddTo.targets)
        graftToAddTo.targets = [];

        //If the graftToAddTo is a Conduit Type, it is waiting for a target to be set on it.
        if (graftToAddTo.type === "Conduit")
        {

            graftToAddTo.name = targetItem;
            graftToAddTo.title = targetItem;
            graftToAddTo.type = "Target";
            graftToAddTo.draft = true;
            graftToAddTo.id = Graft.GenerateId();
            this.setState({
                quickDefGraft: planHolder,
                previousTarget: previousTarget as TargetType
            }, callbackToUse);
        }else
        {
        let newGraft: Graft = {
          id: Graft.GenerateId(),
          type: "Target",
          name: targetItem,
          sequential: true,
          draft: true,
          targets: []
        };
        graftToAddTo.targets.push(newGraft);
        //Set the previous to the last graft clicked before it changes.

        this.lastGraftClicked.push(newGraft);
        this.setState({
            quickDefGraft: planHolder,
            previousTarget: previousTarget as TargetType
        }, callbackToUse);
    }
      //  this.context.setGraftInEdit(planHolder);
    }
      }else
       {
        if (targetItem !== TargetType.CUSTOM)
        {
            planHolder = this.state.quickDefGraft;
            this.setState({
                quickDefGraft: planHolder,
                previousTarget: previousTarget as TargetType
            }, callbackToUse);
           // this.context.setGraftInEdit(planHolder);
        }
       }
    
      //

    //   this.updateWorklist();
    //   this.forceUpdate();
    }


inflowToggled = (e: any, conduitItem: Conduit, inSitu: boolean, callback?: (graftOut: Graft) => void) => {
    this.setState({
        quickError: ""
    });
    //TIGALPHA-177: If the graft in edit is a child and the root graft already has a target then don't change the inflow and maybe show an error instead.
    if (!this.state.CurrentGraft.draft && this.state.CurrentGraft.targets && this.state.CurrentGraft.targets.length > 0)
    {
        //Yes this is ugly but it's easier and it works. Clear the error so it hides the error using css then set it again. (Needs to bump the change so it transitions in and out again.)
        this.setState({
            quickError: ""
        }, ()=>
        {
            this.setState({
                quickError: "A graft may have one inflow only. To create a new graft, please undo, save graft and click new graft. To change inflow of existing graft, please undo and change inflow of first segment."
            })
        });
      
        return;
    }

    let callbackToUse = ()=>
    {
        this.mergeIntoCurrentGraft(this.state.quickDefGraft, callback as any, "", "inflowToggled");
 
    }
    console.log("Inflow Toggled");

    Graft.setRecurseGraft(null);
    let conduitFound = Graft.recurseConduits(this.state.quickDefGraft, conduitItem);
    //let conduitFound = this.state.CurrentGraft.Cn
   let  planHolder = Graft.getRecurseGraft() as Graft;
   
    //1. First check if the inflow selected exists as a conduit or it is on the Aorta.
    if (conduitFound || conduitItem as string === "AORTA")
    {
        if (conduitItem as string === "AORTA")
        {
            planHolder = this.state.quickDefGraft;
            let bottomConduit = Graft.recurseFindBottomConduit(this.state.quickDefGraft, false);
            //If it's the AORTA and there is no bottom target then drop the bottom graft and set the top one to the conduit of the bottom.
            if (!bottomConduit || bottomConduit.type !== "Target")
            {
                planHolder = bottomConduit as Graft;
            }
            if (planHolder)
                planHolder.aortaSelected = true;
        }else
        {
            planHolder.aortaSelected = false;
        }
        if (planHolder)
        {
        
        //if it is then just set the inSitu appropriately.
        planHolder.inSitu = inSitu;
        planHolder.draft = true;
        planHolder.primary = true;  
        planHolder.sequential = true;
        this.setState({quickDefGraft: planHolder, inflowPreference: conduitItem}, callbackToUse);
            //If the conduit doesn't exist in the graft then the inflow is not an existing conduit so ignore.
            return;
        }
    }
    //2. find the graft with the given conduit (Generally the root)
    else if (!conduitFound)
    {
       
        //if the conduit is not found then add it as the parent of the current graft as a Y. (Generally the root of the current graft is where to do this but can change as the level of the graft is busy.)
       planHolder = this.state.quickDefGraft;
       //TODO: Perhaps the type should be different but is still a source?
       if (!(planHolder.name && planHolder.type === "Target" ))
       {
        planHolder.type = "Conduit";
       }
       planHolder.draft = true;
       planHolder.primary = false;  
       planHolder.sequential = false;
       let targetsIn = [
        planHolder
        ];
        if (!planHolder.conduit && planHolder.blankNewItem)
            targetsIn = [];
       let rootGraft: Graft = {
            conduit: conduitItem,
            type: "Source",
            title: conduitItem,
            inSitu: inSitu,
            targets: targetsIn
       };
       //this.context.setGraftInEdit(planHolder);
       this.setState({quickDefGraft: rootGraft}, callbackToUse);
    }
}


 yGraftTypeSelected= (targetSelected: string, callback: () => void) =>
 {

     let bottomTarget: Graft = Graft.recurseFindBottomTarget(this.state.quickDefGraft) as Graft;
     if (targetSelected)
     {
        bottomTarget.sequential = false;
        bottomTarget.conduit = this.state.quickDefGraft.conduit;
     }
     //Selects where to place the Y that will be added.
     this.mergeIntoCurrentGraft(this.state.quickDefGraft, callback, targetSelected, "yGraftTypeSelected");
        

 }

 graftsUpdated = () =>
{
    this.forceUpdate();
   // this.props.updateParent();
}

//Add the graft section defined to the current graft and clear it.
addGraftItem = () =>
{
    
    this.mergeIntoCurrentGraft(this.state.CurrentGraft, ()=>{}, "", "ClearDraft");
    //Clear what is shown in the quick definitions
    let graftNew = Graft.getBlankGraft(false);
    //TIGALPHA-176: Maintain conduit selection
    if (this.state.CurrentGraft.conduit)
    {
        graftNew.conduit = this.state.CurrentGraft.conduit;
    }
    this.setState({

        quickDefGraft: graftNew,
        inflowPreference: (this.state.CurrentGraft.conduit ? this.state.CurrentGraft.inSitu ? null :  this.state.CurrentGraft.conduit : null) as string
    }, this.graftsUpdated);
}

populateCalculatorButtons = () =>
{
   this.freqConduitsContainer= [];
    this.otherConduitsContainer = [];
    this.rightTargetsContainer = [];
    this.leftTargetsContainer = [];

    this.freqInflowConduitsContainer = [];
    this.otherInflowConduitsContainer = [];
    this.other2InflowConduitsContainer = [];
    this.complexGraftToolbar = <></>;
    this.targetHasBeenSelected = false;
    this.graftFound = new Graft();
         let keyIndex = 0;
    Object.keys(Conduit).forEach(conduit => {
        //Add priority 0 conduits first.
        if (TargetDetails.getTargetDetail(conduit).priority === 0)
        {
            
            //let isSelected = Graft.recurseConduits(this.state.CurrentGraft, conduit, )
            let ItemToAdd: React.ReactElement = <li
            className={"worklist-frequently-used-item third-space conduit " + (Graft.recurseFindBottomConduit(this.state.quickDefGraft, false)&& Graft.recurseFindBottomConduit(this.state.quickDefGraft, false)?.conduit === conduit ? "selected" : "" )+ (this.conduitInUse(conduit as Conduit) ? " saved" : "" )}
            key={keyIndex}
            onClick={(e) => {
                this.conduitToggled(e, conduit as Conduit)
        }}>
            {conduit}
          
        </li>;
        if (TargetDetails.getTargetDetail(conduit).mostUsed)
        {
            this.freqConduitsContainer.splice(0, 0,
                ItemToAdd
            );
        }else
        {
            this.freqConduitsContainer.push(
                ItemToAdd
            );
        }
        keyIndex++;
        }else if (TargetDetails.getTargetDetail(conduit).priority > 0)
        {
                //Add priority higher than 0 conduits as other conduits.
        this.otherConduitsContainer.push(
            <li
                className={"worklist-frequently-used-item third-space conduit " + (Graft.recurseFindBottomConduit(this.state.quickDefGraft, false)&& Graft.recurseFindBottomConduit(this.state.quickDefGraft, false) && Graft.recurseFindBottomConduit(this.state.quickDefGraft, false)?.conduit === conduit ? "selected" : "" )+ (this.conduitInUse(conduit as Conduit) ? " saved" : "" )}
                key={keyIndex}
                onClick={(e) => {
                    this.conduitToggled(e, conduit as Conduit)
            }}>
                {conduit}
                
            </li>
        );
        keyIndex++;
        }
    });

    //Next generate inflow section based on conduits.

    //Add Aorta First.
    let aortaIn: string = "Aorta";
    //When the CurrentGraft is Free then it is on the AORTA
    //TODO: Unless the graft in further down in a graft?
    let ItemToAdd: React.ReactElement = <li
    className={"worklist-frequently-used-item third-space conduit " + (this.checkInflowButton("AORTA" as Conduit, false)  ? "selected" : "" ) + ((!this.state.CurrentGraft.draft && this.state.CurrentGraft.aortaSelected )  ? " saved" : "" )}
    key={keyIndex}
    onClick={(e) => {
        this.inflowToggled(e, "AORTA" as Conduit, false)
    }}>
        {aortaIn}
       
    </li>;
    this.freqInflowConduitsContainer.push(
        ItemToAdd
    );
    Object.keys(Conduit).forEach(conduit => {
      
     
        // Next add Source Targets priority 0 with in situ. eg. LITA in situ RITA in situ
        if (TargetDetails.getTargetDetail(conduit).isSource && TargetDetails.getTargetDetail(conduit).priority < 2 )
        {
            let ItemToAdd: React.ReactElement = <li
            className={"worklist-frequently-used-item third-space conduit " + (this.checkInflowButton(conduit as Conduit, true)  ? "selected" : "" ) + (this.isInflowUsed(conduit as Conduit, true) ? " saved" : "" )}
            key={keyIndex}
            onClick={(e) => {
                this.inflowToggled(e, conduit as Conduit, true)
            }}>
                {conduit}
               
            </li>;
           
           if (TargetDetails.getTargetDetail(conduit).mostUsed)
           {
               this.freqInflowConduitsContainer.splice(1, 0,
                   ItemToAdd
               );
           }else
           {
                this.freqInflowConduitsContainer.push(
                   ItemToAdd
               );
           }
      


            keyIndex++;


        //       // Next add Source Targets priority 1 with free. eg. LITA Free RITA Free
        //    //Add priority 1 conduits as other conduits.
        //    let ItemToAdd2: React.ReactElement =
        //     <li
        //         className={"worklist-frequently-used-item third-space conduit " +(this.checkInflowButton(conduit as Conduit, false)  ? "selected" : "" )+ (this.isInflowUsed(conduit as Conduit, false) ? " saved" : "" )}
        //         key={keyIndex}
        //         onClick={(e) => {
        //             this.inflowToggled(e, conduit as Conduit, false)
        //     }}>
        //         {conduit + " free"}
                
        //     </li>
        // ;

        // if (TargetDetails.getTargetDetail(conduit).mostUsed)
        // {
        //     this.otherInflowConduitsContainer.splice(1, 0,
        //         ItemToAdd2
        //     );
        // }else
        // {
        //     this.otherInflowConduitsContainer.push(
        //         ItemToAdd2
        //     );
        // }

        // keyIndex++;
        } 
           //Add none source and priority 0 conduits next. eg SVG.
           else if (!TargetDetails.getTargetDetail(conduit).isSource && TargetDetails.getTargetDetail(conduit).priority === 0 )
           {
               //SVG and RA can never be selected here.
               let ItemToAdd: React.ReactElement = <li
               className={"worklist-frequently-used-item third-space conduit " + (this.checkInflowButton(conduit as Conduit, false)  ? "selected" : "" )+ (this.isInflowUsed(conduit as Conduit, false) ? " saved" : "" )}
               key={keyIndex}
               onClick={(e) => {
                   this.inflowToggled(e, conduit as Conduit, false)
               }}>
                   {conduit}
                  
               </li>;
                //Add these at the start so source options come after.
                this.otherInflowConduitsContainer.splice(0, 0,
                       ItemToAdd
                   );

               keyIndex++;
           }
      
          //Add none source and priority 1 conduits next. eg RA.
          else if (!TargetDetails.getTargetDetail(conduit).isSource && TargetDetails.getTargetDetail(conduit).priority === 1 )
          {
                //SVG and RA can never be selected here.
              let ItemToAdd: React.ReactElement = <li
              className={"worklist-frequently-used-item third-space conduit " + (this.checkInflowButton(conduit as Conduit, false)  ? "selected" : "" )+ (this.isInflowUsed(conduit as Conduit, false) ? " saved" : "" )}
              key={keyIndex}
              onClick={(e) => {
                  this.inflowToggled(e, conduit as Conduit, false)
              }}>
                  {conduit}
              </li>;
           
           this.other2InflowConduitsContainer.push(
                      ItemToAdd
                  );

              keyIndex++;
          }
          // Next add Source Targets priority 2 with free. eg. GEA Free GEA in situ
        else if  (TargetDetails.getTargetDetail(conduit).isSource && TargetDetails.getTargetDetail(conduit).priority === 2)
        {
                //Add priority 2 conduits as other other conduits.
        //         this.other2InflowConduitsContainer.push(
        //     <li
        //         className={"worklist-frequently-used-item third-space conduit " + ( this.checkInflowButton(conduit as Conduit, false) ? "selected" : "" )+ (this.isInflowUsed(conduit as Conduit, false) ? " saved" : "" )}
        //         key={keyIndex}
        //         onClick={(e) => {
        //             this.inflowToggled(e, conduit as Conduit, false)
        //     }}>
        //         {conduit + " free"}
             
        //     </li>
        // );
        this.other2InflowConduitsContainer.push(
            <li
                className={"worklist-frequently-used-item third-space conduit " + (this.checkInflowButton(conduit as Conduit, true)  ? "selected" : "" )+ (this.isInflowUsed(conduit as Conduit, true) ? " saved" : "" )}
                key={keyIndex}
                onClick={(e) => {
                    this.inflowToggled(e, conduit as Conduit, true)
            }}>
                {conduit}
                
            </li>
        );
        keyIndex++;
        }
    });


    Object.keys(TargetType).forEach(target => {
        console.log("Processing target - " + target);
        if (target !== TargetType.CUSTOM) 
         //Add priority 0 targets first.
         if (TargetDetails.getTargetDetail(target).priority === 0)
         {
            let isSelected = Graft.recurseTargets(this.state.quickDefGraft, target as TargetType);
           //If it is selected it is always enabled. If not check if it is used previously.
            let alreadyInUse = this.targetInUse(target as TargetType, isSelected);
            if (isSelected)
            {
                this.targetHasBeenSelected = true;
            }
             let ItemToAdd: React.ReactElement  
             =  <PlannerButton key={target} context="QuickDefinitions" title={target as TargetType}  selected={isSelected} hasactions={Graft.recurseToFindDepth(this.state.quickDefGraft, target as TargetType, 0) > 1} onClick={this.targetToggled} addConduit={this.setConduit} rootGraft={this.state.quickDefGraft} customText={this.props.customGraftText} customTextChanged={()=>
                {}} ymenuEnabled={false} disabled={alreadyInUse}></PlannerButton>;

            if (TargetDetails.getTargetDetail(target).mostUsed)
            {
                //Most used conduits go at the start.
                this.leftTargetsContainer.splice(0, 0, ItemToAdd);
            }else
            {
                this.leftTargetsContainer.push(ItemToAdd);
            }
           
        keyIndex++;
        }else if (TargetDetails.getTargetDetail(target).priority === 1)
        {  
            let isSelected = Graft.recurseTargets(this.state.quickDefGraft, target as TargetType);
            //If it is selected it is always enabled. If not check if it is used previously.
            let alreadyInUse = this.targetInUse(target as TargetType, isSelected);
            if (isSelected)
            {
                this.targetHasBeenSelected = true;
            }
            let ItemToAdd: React.ReactElement
            =  <PlannerButton key={target} rightcolumn={false} context="QuickDefinitions" title={target as TargetType}  selected={isSelected} hasactions={Graft.recurseToFindDepth(this.state.quickDefGraft, target as TargetType, 0) > 1} onClick={this.targetToggled} addConduit={this.setConduit} rootGraft={this.state.quickDefGraft} customText={this.props.customGraftText} customTextChanged={()=>
               {}} ymenuEnabled={false} disabled={alreadyInUse}></PlannerButton>;
            this.rightTargetsContainer.push(
                ItemToAdd
            );
            keyIndex++;
        }
    });


let ySourceSection: React.ReactElement = <></>;
let bottomTarget: Graft = Graft.recurseFindBottomTarget(this.state.quickDefGraft) as Graft;

    if (bottomTarget)
    {
if (Graft.recurseToFindDepth(this.state.CurrentGraft, null as any,  1, 1) > 2 && bottomTarget)
{

    let parentOfTarget = Graft.recurseFindTargetParent(this.state.CurrentGraft, bottomTarget.name as TargetType);
    //if the parent of the target isn't found there is no default yTypeSelected so do nothing ths time
    
    let ySourcesPossible: string[] = [];
    let ySourcesPossibleButtons: React.ReactElement[] = [];
    let yTypeSelected = this.state.yTypeSelected;
    if (parentOfTarget)
    {
    
 yTypeSelected = parentOfTarget.name as string;
    // this.setState({
    //     yTypeSelected: parentOfTarget.name as string
    // });
}
       let CurrentGraftSequential = bottomTarget.sequential;

    if(!CurrentGraftSequential)
    {
      
        
            ySourcesPossible = ySourcesPossible.concat(Graft.recurseTargetsForYConduits(this.state.CurrentGraft, bottomTarget.name as string, false, bottomTarget.name));
           
        for (let index = 0; index < ySourcesPossible.length; index++) {
            const element = ySourcesPossible[index];
            let yGraftToShow = Graft.recurseToFindConduit(this.state.CurrentGraft, element as TargetType, null as any);
            ySourcesPossibleButtons.push(
            <span
            className={"worklist-frequently-used-item advanced-inflow-target composite intuiButton " + (!CurrentGraftSequential && yTypeSelected === element ? "selected" : "") } onClick={()=>{
                this.setState({
                    yTypeSelected: element
                }, ()=>
                {
                    this.yGraftTypeSelected(yTypeSelected, ()=>
                    {
                        this.forceUpdate();
                    });
                 
                });
               }}>{yGraftToShow}</span> as React.ReactElement
            );
            
        } 
        ySourceSection = <div
        className="worklist-frequently-used seq-comp conduit-container-x">
            
            <h4 className="advanced-inflow-caption">Attach to inflow of:</h4>
            {ySourcesPossibleButtons}
        </div>;
    }

    this.complexGraftToolbar = <>
    <div className="worklist-frequently-used seq-comp conduit-container-x">
    <h4>Type</h4>
    <li
        className={"worklist-frequently-used-item half-space composite " + (CurrentGraftSequential ? "selected" : "") }
        onClick={(e) => {
            let bottomTargetFound: Graft = Graft.recurseFindBottomTarget(this.state.quickDefGraft) as Graft;
            bottomTargetFound.sequential = true;
            this.setState({
                yTypeSelected: ""
            }, ()=>{
                this.yGraftTypeSelected(this.state.yTypeSelected, ()=>
                {
                    this.forceUpdate();
                });
               
            });
          
    }}>
    Sequential</li>
    <li
        className={"worklist-frequently-used-item half-space composite " + (!CurrentGraftSequential ? "selected" : "") }
        onClick={(e) => {
            let bottomTargetFound: Graft = Graft.recurseFindBottomTarget(this.state.quickDefGraft) as Graft;
            bottomTargetFound.sequential = false;
            if (!this.state.yTypeSelected)
            {
                let ySourcesPossibleFound = Graft.recurseTargetsForYConduits(this.state.CurrentGraft, bottomTarget.name as string, false, bottomTarget.name as string);
                this.setState({
                    yTypeSelected: ySourcesPossibleFound[0]
                }, ()=>
                {
                    this.yGraftTypeSelected(this.state.yTypeSelected, ()=>
                    {
                        this.forceUpdate();
                    });
                  
                });
            }else
            {
                this.yGraftTypeSelected(this.state.yTypeSelected, ()=>
                {
                    this.forceUpdate();
                });
            }
           
           
    }}>
    Y/T graft</li>
    </div>
    {ySourceSection}
    </>;
}
}

}

setEditGraft = (targetClicked: TargetType) =>
  {
    let graftToLoad = Graft.getBlankGraft(false);
    //If the target in edit is set and it is an item in edit and not a blank new one
    if (this.state.CurrentGraft && targetClicked)
    {
        if (Graft.recurseTargets(this.state.CurrentGraft, targetClicked, false))
        {
            this.graftFound.draft = true;
            this.graftFound.inEdit = true;
            graftToLoad = { ...this.graftFound };
            graftToLoad.inEdit = true;
            if (!graftToLoad.conduit)
            {
                //If the graft has no conduit find it.
               
                let ConduitFound = Graft.recurseToFindConduit(this.state.CurrentGraft, targetClicked,"" as any ) as Conduit;
                graftToLoad.conduit = ConduitFound;
               
            }
             //If we are editting the graft then chances are it is a Target
             graftToLoad.type = "Target";
             graftToLoad.draft = true;
             //Only edit the current level.
             graftToLoad.targets = [];
        }
    }

    this.setState({
        quickDefGraft: graftToLoad
    });
  }

planUndo = () =>
{
    this.mergeIntoCurrentGraft(this.state.CurrentGraft, (graftParent) =>
    {

        if (graftParent != null)
        {
           
        }else
        {

            graftParent = Graft.getBlankGraft(false);
        }
        if (graftParent.type === "Target" && graftParent.name)
            this.setEditGraft(graftParent.name);
        else
            this.setState({
                quickDefGraft: graftParent
            })
    }, "", "Undo");
   
}

planDeleted = ()=>
{

    let graftParent = Graft.getBlankGraft(false);

    this.setState({
        quickDefGraft: graftParent
    }, ()=>
    {
       // this.context.PlanDeleted(null);
    });


}



    render() {
this.populateCalculatorButtons();

let graftContainer = <div className="quick-definition-scroll">
    
    <div className="quick-definition-container">

{
    this.freqConduitsContainer
        ? <div className="worklist-frequently-used conduit-container-x bottom-space">
                <h4>
                    Conduit
                </h4>
                {this.freqConduitsContainer}
                <div className="invisible-separator"></div>
                {this.otherConduitsContainer}
            </div>
        : null
}
{
    this.freqConduitsContainer
        ? <div className="worklist-frequently-used conduit-container-x bottom-space">
                <h4>
                    Inflow
                    {
                        this.state.quickError ? <div className="elementToFadeInAndOut">{this.state.quickError}</div> : null
                    }
                </h4>

                {this.freqInflowConduitsContainer}
                <div className="invisible-separator"></div>
                {this.otherInflowConduitsContainer}
                <div className="invisible-separator"></div>
                {this.other2InflowConduitsContainer}
            </div>
        : null
}
{
    this.leftTargetsContainer
        ? <div className="worklist-frequently-used conduit-container-x bottom-space">
                <h4>
                    Target
                </h4>
                {this.leftTargetsContainer}
                <div className="dotted-separator"></div>
                {this.rightTargetsContainer}
            </div>
        : null
}


{
     <>
        {this.complexGraftToolbar}
        <div className="quickdef-save-container">
        
        {/* <a href="/#" className="ghost-pebble-button delete-button" onClick={()=> {this.planDeleted();}}>DELETE</a>   */}
        <a href="/#" className="ghost-pebble-button delete-button intuiButton iconButton " onClick={()=> {this.planUndo()}}>
            <svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26 10C26 11.5 25.6823 12.9167 25.0469 14.25C24.4219 15.5729 23.5365 16.7188 22.3906 17.6875L5.64062 31.7656C5.45312 31.9219 5.23958 32 5 32C4.72917 32 4.49479 31.901 4.29688 31.7031C4.09896 31.5052 4 31.2708 4 31C4 30.8542 4.03125 30.7135 4.09375 30.5781C4.15625 30.4427 4.24479 30.3281 4.35938 30.2344L21.1094 16.1562C22.0781 15.3438 22.8021 14.401 23.2812 13.3281C23.7604 12.2552 24 11.0938 24 9.84375C24 9.14583 23.901 8.46875 23.7031 7.8125C23.5156 7.15625 23.2448 6.53646 22.8906 5.95312C22.5469 5.36979 22.1302 4.83854 21.6406 4.35938C21.1615 3.86979 20.6302 3.45312 20.0469 3.10938C19.4635 2.75521 18.8438 2.48438 18.1875 2.29688C17.5312 2.09896 16.8542 2 16.1562 2C15.1771 2 14.2396 2.15104 13.3438 2.45312C12.4583 2.75521 11.6406 3.21875 10.8906 3.84375L3.5 10H11C11.2708 10 11.5052 10.099 11.7031 10.2969C11.901 10.4948 12 10.7292 12 11C12 11.2708 11.901 11.5052 11.7031 11.7031C11.5052 11.901 11.2708 12 11 12H1C0.729167 12 0.494792 11.901 0.296875 11.7031C0.0989583 11.5052 0 11.2708 0 11V1C0 0.729167 0.0989583 0.494792 0.296875 0.296875C0.494792 0.0989583 0.729167 0 1 0C1.27083 0 1.50521 0.0989583 1.70312 0.296875C1.90104 0.494792 2 0.729167 2 1V8.64062L9.60938 2.3125C10.5052 1.5625 11.5 0.989583 12.5938 0.59375C13.6979 0.197917 14.8333 0 16 0C17.3854 0 18.6823 0.260417 19.8906 0.78125C21.1094 1.30208 22.1719 2.01562 23.0781 2.92188C23.9844 3.82812 24.6979 4.89062 25.2188 6.10938C25.7396 7.31771 26 8.61458 26 10Z" fill="black"/>
            </svg>
        </a>  
        <a href="/#" className={"ghost-pebble-button segment-button intuiButton iconButton " + ((this.state.CurrentGraft.targets && this.state.CurrentGraft.targets.length > 0) || this.targetHasBeenSelected ? "button-active" : "disabled")} onClick={
        ()=> {
           if ((this.state.CurrentGraft.targets && this.state.CurrentGraft.targets.length > 0) || this.targetHasBeenSelected)
                this.addGraftItem();
            
            }
        }>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16H2C1.71875 16 1.45312 15.9479 1.20312 15.8438C0.963542 15.7396 0.755208 15.599 0.578125 15.4219C0.401042 15.2448 0.260417 15.0365 0.15625 14.7969C0.0520833 14.5469 0 14.2812 0 14C0 13.7188 0.0520833 13.4583 0.15625 13.2188C0.260417 12.9792 0.401042 12.7708 0.578125 12.5938C0.765625 12.4062 0.979167 12.2604 1.21875 12.1562C1.45833 12.0521 1.71875 12 2 12H12V2C12 1.71875 12.0521 1.45833 12.1562 1.21875C12.2604 0.979167 12.401 0.770833 12.5781 0.59375C12.7656 0.40625 12.9792 0.260417 13.2188 0.15625C13.4583 0.0520833 13.7188 0 14 0C14.2708 0 14.526 0.0520833 14.7656 0.15625C15.0156 0.260417 15.2292 0.40625 15.4062 0.59375C15.5938 0.770833 15.7396 0.984375 15.8438 1.23438C15.9479 1.47396 16 1.72917 16 2V12H26C26.2708 12 26.526 12.0521 26.7656 12.1562C27.0156 12.2604 27.2292 12.4062 27.4062 12.5938C27.5938 12.7708 27.7396 12.9844 27.8438 13.2344C27.9479 13.474 28 13.7292 28 14C28 14.2812 27.9479 14.5417 27.8438 14.7812C27.7396 15.0208 27.5938 15.2344 27.4062 15.4219C27.2292 15.599 27.0208 15.7396 26.7812 15.8438C26.5417 15.9479 26.2812 16 26 16H16V26C16 26.2812 15.9479 26.5417 15.8438 26.7812C15.7396 27.0208 15.5938 27.2344 15.4062 27.4219C15.2292 27.599 15.0208 27.7396 14.7812 27.8438C14.5417 27.9479 14.2812 28 14 28C13.7188 28 13.4531 27.9479 13.2031 27.8438C12.9635 27.7396 12.7552 27.599 12.5781 27.4219C12.401 27.2448 12.2604 27.0365 12.1562 26.7969C12.0521 26.5469 12 26.2812 12 26V16Z" fill="black"/>
            </svg>
        </a>  

        <a href = "/#" className ={"orange large-side-margin save intuiButton "+ ((this.state.CurrentGraft.targets && this.state.CurrentGraft.targets.length > 0) || this.targetHasBeenSelected ? "" : "disabled")} onClick = {
            (e) => {
                //this.addGraftItem();
                if ((this.state.CurrentGraft.targets && this.state.CurrentGraft.targets.length > 0) || this.targetHasBeenSelected)
                {
                    this.props.SaveGraft(this.state.CurrentGraft);
                    //this.context.saveCurrentGraft(false);
                }
                   
            }

        } > Save graft </a>

        </div>
        
        
        
            <div className="invisible-separator"></div>
            {/* <div>
        <a href = "/#" className ={"orange large-side-margin top-margin save " + ((this.state.CurrentGraft.Targets && this.state.CurrentGraft.Targets.length > 0) || targetHasBeenSelected ? "" : "disabled")} onClick = {
            (e) => {
               
            }
        } > Save to worklist </a>
        </div> */}
        </>
} </div></div>;

        let conduitButtons = [];
        for (let conduitItem in Conduit)
        {
            //conduitButtons.push(<PlannerButton title={conduitItem as Conduit}  selected={this.state.theplan.filter((item)=> { return item.Conduit === conduitItem }).length > 0} onClick={this.conduitToggled}></PlannerButton>);
            conduitButtons.push(<PlannerButton title={conduitItem as Conduit}  selected={this.state.CurrentGraft.conduit === conduitItem} onClick={this.conduitToggled} rootGraft={this.state.CurrentGraft} customText={this.props.customGraftText} customTextChanged={this.customTextChanged}></PlannerButton>);
        }
     
        let midPoint = Math.floor(Object.keys(TargetType).length / 2) ;
        let targetButtonsLeft = [];
        let targetButtonsRight = [];
        let lc = 0;
        for (let targetItem in TargetType)
        {
          if (lc < midPoint)
          {
              targetButtonsLeft.push(<PlannerButton key={targetItem} title={targetItem as TargetType}  selected={Graft.recurseTargets(this.state.CurrentGraft, targetItem as TargetType)} hasactions={Graft.recurseToFindDepth(this.state.CurrentGraft, targetItem as TargetType, 0) > 1} onClick={this.targetToggled} addConduit={this.setConduit} rootGraft={this.state.CurrentGraft} customText={this.props.customGraftText} customTextChanged={this.customTextChanged}></PlannerButton>);
          }else{
            targetButtonsRight.push(<PlannerButton key={targetItem}  title={targetItem as TargetType}  selected={Graft.recurseTargets(this.state.CurrentGraft, targetItem as TargetType)} hasactions={Graft.recurseToFindDepth(this.state.CurrentGraft, targetItem as TargetType, 0) > 1}  onClick={this.targetToggled} addConduit={this.setConduit} rightcolumn={true} rootGraft={this.state.CurrentGraft} customText={this.props.customGraftText} customTextChanged={this.customTextChanged}></PlannerButton>);
          }
          lc++;
        }
       
      
        // let customTargetHeartSide: React.ReactElement;
        // if (this.state.waitingCustomTargetHeartSideSet)
        // {
        //   //If waiting for somone to choose whether to put the custom graft on back or front of heart then show a dropdown menu.
        //   customTargetHeartSide =  <ul className="entry-field-dropdown-expanded" 
        //   style={{overflow: "visible", position: "absolute", left: this.state.customGraftLocation.x, top: this.state.customGraftLocation.y+80, display: "block"}}> 
        //   <li onClick={()=>{ this.setCustomTargetFrontOrBack(false); }}>FRONT</li>
        //   <li onClick={()=>{ this.setCustomTargetFrontOrBack(true); }}>BACK</li>
        //   </ul>
        // } else if (this.state.waitingCustomTargetSet)
        // {
        //   customTargetHeartSide = <div className="choose-target-label">Choose target location</div>;
        // }

        let overlayButtonsTargets: React.ReactElement = <></>;
        let overlayButtonsConduits: React.ReactElement = <></>;
        if (!this.props.simpleMode)
        {

          overlayButtonsTargets = 
              <><div className="overlay-buttons column target-left">
                  {targetButtonsLeft}
                </div>
                <div className="overlay-buttons column target-right">
                  {targetButtonsRight}
                </div>
              </>;
          overlayButtonsConduits = 
              <div className="conduit-container overlay-buttons"> 
                {conduitButtons}     
              </div>;
        }
        return (
       
        <div className="graft-builder-container">
            <button className='overlayClose' onClick={() => this.props.closeGraftBuilder()}></button>
           <button className='bigClose' onClick={() => this.props.closeGraftBuilder()}>X</button>
            <div className="planner-container">
          
     <div className="planner-display-container ">

      {overlayButtonsConduits}
 
<div id={"heart-drawing-container-Planner"} className={"row  heart-drawing-container heart-drawing-container-" + this.props.Context} onMouseDown={this.mouseDownOnPlanner}>
  { 
 
  <HeartDrawingOverlay ref="drawingOverlay" 
  GraftsLoaded={[this.state.CurrentGraft]} 
  customGraftLocation={this.state.customGraftLocation}
  heartOutlineShow={this.state.heartOutlineShow}
  heartTargetsShow={this.state.heartTargetsShow}
  drawDebugLine={false}
  Context={"Test"}
  radiusHeart={100}
  horizontalsquashfactor={0.42}
  deadzonefactor={0.30}
  deadzoneyshiftfirsthalf={-90}
  deadzoneyshiftsecondhalf={130}
  width={800}
  height={800}
  heartyOffset={this.props.Context === "QuickDefinitions" ? -420 : 40}
  heartxOffset={0} absxOffset={0} absyOffset={0} editGraftClicked={this.props.editGraftClicked}
  graftSelected={this.props.subGraftSelected} 
  selectedProcedure={{name: "CABG", title: "", type: "Cardiac"}}></HeartDrawingOverlay>
  }

{overlayButtonsTargets}
</div>
    </div>
    </div>
 {graftContainer}
</div>




        );
    }


}
GraftBuilder.contextType = AppContext;
export default GraftBuilder;